import React from 'react';
import { useTheme } from 'styled-components';

import pinLight from 'static/pin.light-mode.svg';
import pinDark from 'static/pin.dark-mode.svg';
import { StyledGraphicImage } from './PinGraphic.styles';

export function PinGraphic() {
  const theme = useTheme();

  return <StyledGraphicImage src={theme.name === 'darkTheme' ? pinDark : pinLight} />;
}

export default PinGraphic;
